(function imageHandler(global) {
  'use strict';

  global.NewHomeSource = global.NewHomeSource || {};
  global.NewHomeSource.Modules = global.NewHomeSource.Modules || {};

  if (!global.NewHomeSource.FullImageViewer.UrlHandler) {
    return;
  }

  const previousImageHandler = global.NewHomeSource.Modules.ImageHandler;

  /**
  * @constructs ImageHandler
  */
  function ImageHandler() {
  }

  /**
  * @public
  * addJpgParameter: add jpg parameter to image source.
  *
  */
  ImageHandler.addJpgParameter = function addJpgParameter(imageSource, queryString) {
    let formatJpg = '';
    let separator = '';
    let beforeFormat = '';
    if (queryString) {
      separator = '&';
      beforeFormat = queryString;
    }
    if (imageSource.indexOf('.gif') > -1) {
      formatJpg = separator + 'format=jpg';
    }

    if (imageSource.indexOf('.png') > -1 || imageSource.indexOf('.svg') > -1) {
      formatJpg = separator + 'format=jpg&backgroundColor=white';
    }

    return global.NewHomeSource.FullImageViewer.UrlHandler.insertQueryString(imageSource, beforeFormat + formatJpg);
  };

  /**
   * @public
   *
   * noConflict: Returns control of NewHomeSource.Modules.ImageHandler to the previous script.
   */
  ImageHandler.noConflict = function noConflict() {
    global.NewHomeSource.Modules.ImageHandler = previousImageHandler;
    return ImageHandler;
  };

  global.NewHomeSource.Modules.ImageHandler = ImageHandler;
}(window));
